const PlatformActionTypes = {
  SET_CURRENT_VERSION: "SET_CURRENT_VERSION",
}

export default PlatformActionTypes
